import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '@app/network/apiClient';
import { workspacesUrl } from '@app/definition/API';
import { WorkspaceDetailsInterface } from './types';
import setWorkspace from './setThunk';

const fetchWorkspaces = createAsyncThunk(
  'workspaces/fetchWorkspaces',
  async (data, { dispatch }) => {
    try {
      const response = await apiClient(workspacesUrl);

      if (response.status >= 400) {
        throw new Error(response.data.message || 'Invalid response!');
      }

      const workspaces = response.data.data as WorkspaceDetailsInterface[];
      const selectedWorkspaceId = Number(
        localStorage.getItem('selectedWorkspaceId')
      );

      if (selectedWorkspaceId || workspaces.length === 1) {
        const defaultWorkspace = selectedWorkspaceId
          ? workspaces.find(
              (workspace) => workspace.company?.id === selectedWorkspaceId
            )
          : workspaces[0];

        dispatch(setWorkspace(defaultWorkspace as WorkspaceDetailsInterface));
      }

      return workspaces || [];
    } catch (error) {
      throw new Error(error as string);
    }
  }
);

export default fetchWorkspaces;
